module.exports = __webpack_public_path__ + "static/img/tips.8c49da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/necklace/tips.png
// module id = CoeC
// module chunks = 1